import { SolicitacaoAnalise } from "./SolicitacaoAnalise";

export default SolicitacaoAnalise;